export const PaymentBlockV3 = {
  props: ['financeValue', 'leaseValue', 'cashRebate', 'leaseRebate', 'leaseRebateScale', 'financeData', 'priceValue', 'msrpValue', 'salePrice', 'residualMsrp', 'lang', 'provinceTax', 'taxed', 'customDownPayment', 'customPaymentType', 'frequencySelected', 'useMsrp'],
  data() {
    const msrpBase = parseFloat(this.salePrice) || 0;
    const wantsMsrp = this.useMsrp === true || this.useMsrp === 'true' || this.useMsrp === '1' || this.useMsrp === 1;
    const basePrice = (wantsMsrp && msrpBase > 0) ? msrpBase : (parseFloat(this.priceValue) || 0);
    return {
      cashRebateValue: this.cashRebate,
      leaseRebateValue: this.leaseRebate || 0,
      finance: this.financeValue,
      lease: this.leaseValue,
      isTaxed: (this.taxed && (this.taxed == 'true' || this.taxed == '1')) ? true : false,
      provinceTaxValue: this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13,
      isLease: false,
      discountsVisibility: false,
      discountsStatus: 'closed',
      discountsAddIcon: '+',
      calculatedValue: 0,
      calculatedLeaseValue: 0,
      loanTerm: 0,
      loanTermLease: 0,
      downPayment: this.customDownPayment ? this.customDownPayment : 0,
      tradeInValue: this.$cookies.get('tradeInValue') ? this.$cookies.get('tradeInValue') : 0,
      frequency: this.frequencySelected ? this.frequencySelected : 'weekly',
      vehiclePrice: '' + parseInt(basePrice) + '',
      priceToShow: '' + parseInt(basePrice) + '',
      salesTax: 0,
      interestRate: 0,
      interestRateLease: 0,
      costOfBorrowing: 0,
      costOfBorrowingLease: 0,
      totalObligationLease: 0,
      totalObligationFinance: 0,
      totalMSRP: this.msrpValue,
      termsMock: [
        { term: 12, value: 0 },
        { term: 24, value: 0 },
        { term: 36, value: 0 },
        { term: 48, value: 0 },
        { term: 60, value: 0 },
        { term: 72, value: 0 },
        { term: 84, value: 0 },
      ],
      kilometersAllowance: 25000,
      selectedTab: this.customPaymentType ? this.customPaymentType : 'finance',
      showOptions: false,
      selectedTerm: '',
      selectedFrequency: 'weekly',

      //! Valores para el slider circular de Lease
      minPaymentLease: 0,
      maxPaymentLease: 1000,
      defaultPaymentLease: 500,

      // Valores para el slider circular de Finance
      minPaymentFinance: 0,
      maxPaymentFinance: 1000,
      defaultPaymentFinance: 500,

      // Propiedades para el slider circular de Lease
      leaseRadius: "150",
      leaseStartAngle: "320",
      leaseEndAngle: "+260",

      // Propiedades para el slider circular de Finance
      financeRadius: "150",
      financeStartAngle: "320",
      financeEndAngle: "+260",


      // Valores de downPayment separados para cada tab
      leaseDownPayment: this.customDownPayment ? this.customDownPayment : 0,
      financeDownPayment: this.customDownPayment ? this.customDownPayment : 0,

      // Valores independientes para los sliders (no vinculados a downPayment)
      leaseSliderValue: 500,
      financeSliderValue: 500,

      // Nuevo: slider basado en el valor de lease (calculatedLeaseValue)
      // Estos estados son adicionales para no romper el flujo actual.
      calculatedLeaseValueSlider: 0,    // valor actual del slider (p. ej. 151, 59, ...)

      calculatedLeaseMin: 0,            // valor máximo del lease (cuando downPayment == 0)
      calculatedLeaseMax: 0,            // valor mínimo del lease (cuando downPayment == vehiclePrice)
      leaseSliderActive: false,         // si true, mover este slider actualizará downPayment
      leaseSliderTolerance: 0.8,        // tolerancia para la búsqueda binaria
      leaseSliderSearchIterations: 30,  // iteraciones máximas

      // Nuevo: slider para Finance (calculatedValue)
      calculatedFinanceValueSlider: 0,
      calculatedFinanceMin: 0,
      calculatedFinanceMax: 0,
      financeSliderActive: false,
      financeSliderTolerance: 0.8,
      financeSliderSearchIterations: 30,
      leaseDetailsOpen: false,
      financeDetailsOpen: false,
      leaseDetailsVisibility: false,
      financeDetailsVisibility: false,
      // Mensaje de validación para límite del 20%
      leaseDownPaymentCapMessage: '',
      showLeaseCapWarning: false,
      // Flag para indicar si el down payment fue corregido automáticamente
      leaseDownPaymentWasCapped: false,
    }
  },
  methods: {
    financeDetails(){
      this.financeDetailsVisibility = !this.financeDetailsVisibility;
    },
    financeDetailsOff(){
      this.financeDetailsVisibility = false
    },
    leaseDetails(){
      this.leaseDetailsVisibility = !this.leaseDetailsVisibility;
    },
    leaseDetailsOff(){
      this.leaseDetailsVisibility = false
    },
    selectOption(term) {
      this.loanTermLease = term;
      this.selectedTerm = term;
      this.showOptions = false;
      this.changeInterestRateLease();
    },

    residualLease() {

      const index = this.lease.map(item => { return item.term }).indexOf(this.loanTermLease);
      if (index == -1)
        return 0;

      var metadata = null;
      try {
        metadata = this.lease[index].metadata;
        // el feed manda residual como numero o como {value}
        const raw = JSON.parse(metadata).residual;
        const pct = parseFloat(raw && typeof raw === 'object' ? raw.value : raw);
        if (!isFinite(pct))
          return 0;
        return this.residualBase * (pct + this.leaseAdjustment) / 100;
      }
      catch (e) {
        return 0;
      }
    },
    // Pago adelantado (el primero se paga al firmar), igual que el desk de la financiera.
    leasePayment(capCost, residual) {
      const term = parseFloat(this.loanTermLease) || 0;
      if (term <= 0)
        return 0;
      const rate = (parseFloat(this.interestRateLease) || 0) / 1200;
      if (rate <= 0)
        return (capCost - residual) / term;
      const discount = Math.pow(1 + rate, -term);
      return (capCost - residual * discount) * rate / (1 - discount) / (1 + rate);
    },
    // El impuesto va antes de redondear: redondear dos veces movía el pago un dólar.
    leaseDisplayValue(monthly) {
      let value = monthly;
      if (this.frequency == "weekly")
        value = (monthly * 12) / 52;
      else if (this.frequency == "bi-weekly")
        value = (monthly * 12) / 26;
      if (this.isTaxed)
        value = value * (this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13);
      value = Math.round(value);
      return isFinite(value) ? value : 0;
    },
    discountsDetails(){
      this.discountsVisibility = !this.discountsVisibility;
      this.discountsStatus = 'opening'
      if(this.discountsAddIcon == '+')
        this.discountsAddIcon = '-'
      else
        this.discountsAddIcon = '+'
    },
    usdFormat(value) {
      var formatter = new Intl.NumberFormat(this.lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
      });

      return formatter.format(value);
    },
    onFocus(value) {
      if (value == 'downPayment' && this.downPayment == 0){
        this.downPayment = '';
    }
      if (value == 'tradeInValue' && this.tradeInValue == 0){
        this.tradeInValue = '';
      }
    },
    calculateVehiclePrice(){
      //Linear tax calculation. ?
      if (this.isTaxed) {
        this.priceToShow = Math.round(this.vehiclePrice * this.provinceTaxValue);
      } else {
        this.priceToShow = this.vehiclePrice
      }
    },
    handleTax() {
      this.isTaxed = !this.isTaxed;
      this.calculateVehiclePrice();
      this.calculatePayment();
      this.calculateLeasePayment();
      // Los bounds de los sliders circulares se derivan del pago calculado, así que al
      // cambiar el tax hay que recomputarlos y resincronizar el thumb con el nuevo valor.
      this.computeLeaseSliderBounds();
      this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
      this.computeFinanceSliderBounds();
      this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
    },
    blur(value) {
      if (value == 'downPayment' && this.downPayment == ''){
          this.downPayment = 0;
      }
      if (value == 'tradeInValue' && this.tradeInValue == ''){
        this.tradeInValue = 0;
      }
      // Validar límite del 20% para lease cuando el usuario escribe manualmente
      this.validateLeaseDownPaymentCap(value);
    },
    // Método específico para manejar blur del down payment en lease
    onLeaseDownPaymentBlur() {
      // Primero manejar el caso de valor vacío
      if (this.downPayment === '' || this.downPayment === null) {
        this.downPayment = 0;
      }

      // Verificar si el valor excede el límite O si fue corregido automáticamente por el watcher
      const downPaymentNum = parseFloat(this.downPayment) || 0;
      const maxDownPayment = this.maxLeaseDownPayment;
      const exceededLimit = downPaymentNum > maxDownPayment;
      const wasCapped = this.leaseDownPaymentWasCapped;

      if (exceededLimit || wasCapped) {
        // Corregir el valor si aún excede
        if (exceededLimit) {
          this.downPayment = maxDownPayment;
          this.leaseDownPayment = maxDownPayment;
        }

        // Resetear el flag
        this.leaseDownPaymentWasCapped = false;

        // Mostrar el mensaje de validación
        this.$nextTick(() => {
          this.leaseDownPaymentCapMessage = `Down payment + trade-in cannot exceed 20% of vehicle price (max: ${this.usdFormat(maxDownPayment)})`;
          this.showLeaseCapWarning = true;
          // Auto-ocultar después de 5 segundos
          setTimeout(() => {
            this.showLeaseCapWarning = false;
          }, 5000);
        });
      }

      // Recalcular (los watchers también lo harán, pero lo dejamos por consistencia)
      this.calculateLeasePayment();
      this.computeLeaseSliderBounds();
      this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
    },
    // Método específico para manejar blur del trade-in en lease
    onLeaseTradeInBlur() {
      // Primero manejar el caso de valor vacío
      if (this.tradeInValue === '' || this.tradeInValue === null) {
        this.tradeInValue = 0;
      }

      // Validar que el down payment actual no exceda el nuevo límite
      // (ya que el trade-in afecta el máximo down payment permitido)
      const downPaymentNum = parseFloat(this.downPayment) || 0;
      const maxDownPayment = this.maxLeaseDownPayment;
      const exceededLimit = downPaymentNum > maxDownPayment;
      const wasCapped = this.leaseDownPaymentWasCapped;

      if (exceededLimit || wasCapped) {
        // Corregir el valor del down payment si aún excede
        if (exceededLimit) {
          this.downPayment = maxDownPayment;
          this.leaseDownPayment = maxDownPayment;
        }

        // Resetear el flag
        this.leaseDownPaymentWasCapped = false;

        // Mostrar el mensaje de validación
        this.$nextTick(() => {
          this.leaseDownPaymentCapMessage = `Down payment + trade-in cannot exceed 20% of vehicle price (max: ${this.usdFormat(maxDownPayment)})`;
          this.showLeaseCapWarning = true;
          // Auto-ocultar después de 5 segundos
          setTimeout(() => {
            this.showLeaseCapWarning = false;
          }, 5000);
        });
      }

      // Recalcular (los watchers también lo harán, pero lo dejamos por consistencia)
      this.calculateLeasePayment();
      this.computeLeaseSliderBounds();
      this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
    },
    // Método para validar y corregir el límite del 20% en lease (mantener para compatibilidad)
    validateLeaseDownPaymentCap(value) {
      if (this.selectedTab === 'lease') {
        if (value == 'downPayment' || value == 'tradeInValue') {
          const downPaymentNum = parseFloat(this.downPayment) || 0;
          const maxDownPayment = this.maxLeaseDownPayment;
          if (downPaymentNum > maxDownPayment) {
            // Mostrar mensaje de validación
            this.showLeaseCapMessage();
            // Corregir el valor
            this.downPayment = maxDownPayment;
            this.leaseDownPayment = maxDownPayment;
            // Recalcular
            this.calculateLeasePayment();
            this.computeLeaseSliderBounds();
            this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
            return true;
          }
        }
      }
      return false;
    },
    // Método para mostrar mensaje de validación del cap del 20%
    showLeaseCapMessage() {
      // Usar el mismo valor que maxLeaseDownPayment para consistencia
      const maxDownPayment = this.maxLeaseDownPayment;
      this.leaseDownPaymentCapMessage = `Down payment + trade-in cannot exceed 20% of vehicle price (max: ${this.usdFormat(maxDownPayment)})`;
      this.showLeaseCapWarning = true;
      // Auto-ocultar después de 5 segundos
      setTimeout(() => {
        this.showLeaseCapWarning = false;
      }, 5000);
    },
    numberFormat(value) {
      return new Intl.NumberFormat(this.lang).format(value);
    },
    toggle: function () {
      this.isLease = !this.isLease
      this.loanTerm = this.termsOptions[this.termsOptions.length - 1];
      this.changeInterestRate();
      this.changeInterestRateLease();
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    togglePlan: function (plan) {
      this.frequency = plan;
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    close: function () {
      this.$emit('close');
    },
    calculatePayment: function () {

        var total = 0
        var term = 60
        if (this.loanTerm != 0)
          term = this.loanTerm;
        if (this.interestRate == 0)
          total = Math.round(((this.remainingVehiclePrice - this.residual) / term) * 100) / 100;
        else
          total = Math.round((((this.remainingVehiclePrice - this.residual) * (this.interestRate / 1200)) * Math.pow((1 + (this.interestRate / 1200)), term)) / (Math.pow((1 + (this.interestRate / 1200)), term) - 1) * 100) / 100;

        this.amountFinanced = (Math.round(total * term) * 100 / 100)
        this.costOfBorrowing = (Math.round((this.amountFinanced - this.remainingVehiclePrice) *  ( this.provinceTaxValue) * 100) / 100).toFixed(0);
        if (this.costOfBorrowing < 0)
          this.costOfBorrowing = 0;

        // Calculate Total Obligation for Finance
        let downPaymentValue = this.downPayment && this.downPayment > 0 ? parseFloat(this.downPayment) : 0;
        this.totalObligationFinance = this.amountFinanced + downPaymentValue;

        if (this.frequency == "weekly")
          this.calculatedValue = Math.round(((total * 12) / 52).toFixed(2));
        else if (this.frequency == "bi-weekly")
          this.calculatedValue = Math.round(((total * 12) / 26).toFixed(2));
        else
          this.calculatedValue = Math.round(total.toFixed(2));

        //Linear tax calculation. ?
        let provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
        if (this.isTaxed) {
          this.calculatedValue = Math.round((this.calculatedValue * provinceDealerTax).toFixed(0));
          this.totalObligationFinance = Math.round((this.totalObligationFinance * provinceDealerTax).toFixed(0));
        }


      // alert("CALCULATE" + this.calculatedValue);
    },
    calculateLeasePayment: function () {
      // Validar límite del 20% para lease antes de calcular
      // NOTA: Solo corregimos el valor aquí y marcamos el flag.
      // El mensaje se muestra en onLeaseDownPaymentBlur() cuando detecta el flag.
      if (this.selectedTab === 'lease') {
        const downPaymentNum = parseFloat(this.downPayment) || 0;
        const maxDownPayment = this.maxLeaseDownPayment;
        if (downPaymentNum > maxDownPayment) {
          this.downPayment = maxDownPayment;
          this.leaseDownPayment = maxDownPayment;
          // Marcar que el valor fue corregido para que el blur muestre el mensaje
          this.leaseDownPaymentWasCapped = true;
        }
      }

      var total = 0;
      var residualValue = this.residualLease();
      var leaseCapCost = this.remainingVehiclePrice - this.effectiveLeaseRebate;

      total = this.leasePayment(leaseCapCost, residualValue);

      this.amountFinanced = leaseCapCost - residualValue;
      this.costOfBorrowingLease = (Math.round(((total * this.loanTermLease) - this.amountFinanced) * 100) / 100).toFixed(0);

      if (this.costOfBorrowingLease < 0)
        this.costOfBorrowingLease = 0;

      // Calculate Total Obligation for Lease
      let downPaymentValue = this.downPayment && this.downPayment > 0 ? parseFloat(this.downPayment) : 0;
      this.totalObligationLease = (total * this.loanTermLease) + downPaymentValue;

      this.calculatedLeaseValue = this.leaseDisplayValue(total);

      //Linear tax calculation. ?
      let provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
      if (this.isTaxed) {
        this.totalObligationLease = Math.round((this.totalObligationLease * provinceDealerTax).toFixed(0));
      }
    },
    changeInterestRate() {
      this.setInterestRate();
      this.calculatePayment();
    },
    changeInterestRateLease() {
      this.setInterestRateLease();
      this.calculateLeasePayment();
    },
    // devuelve el valor (percent) asociado a un término de lease
    getLeaseTermValue(termNumber) {
      try {
        const idx = this.termsLease.map(item => item.term).indexOf(termNumber);
        if (idx !== -1) return this.termsLease[idx].value;
      } catch (e) {}
      return '';
    },

    // devuelve el valor (percent) asociado a un término de finance
    getFinanceTermValue(termNumber) {
      try {
        const idx = this.terms.map(item => item.term).indexOf(termNumber);
        if (idx !== -1) return this.terms[idx].value;
      } catch (e) {}
      return '';
    },
    setInterestRate() {
      const index = this.terms.map(item => { return item.term }).indexOf(this.loanTerm);
      if (this.terms[index].value > 50)
        this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100) / 100;
      else
        this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100);
    },
    setInterestRateLease() {
      const index = this.termsLease.map(item => { return item.term }).indexOf(this.loanTermLease);
      if (this.termsLease[index].value > 50)
        this.interestRateLease = parseFloat(Math.round(this.termsLease[index].value * 100) / 100) / 100;
      else
        this.interestRateLease = parseFloat(Math.round(this.termsLease[index].value * 100) / 100);
    },

    // --- Nuevos métodos para slider por calculatedLeaseValue ---
    // calcula el lease payment (valor final mostrado) para un downPayment dado
    computeLeasePaymentForDownPayment(downPaymentValue) {
      // replicamos la lógica de remainingVehiclePrice localmente para no alterar this.downPayment
      const tradeInValueN = (this.tradeInValue && this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      const dpN = downPaymentValue && downPaymentValue > 0 ? parseFloat(downPaymentValue) : 0;
      const vehiclePriceN = parseInt(this.vehiclePrice) || 0;

      let remaining = vehiclePriceN;
      if (tradeInValueN) remaining -= tradeInValueN;
      if (dpN) remaining = remaining - (dpN / this.provinceTaxValue);

      // residual para lease (usa metadataLease actual y loanTermLease)
      let residualValue = 0;
      try {
        const index = this.lease.map(item => item.term).indexOf(this.loanTermLease);
        if (index !== -1) {
          const metadata = this.lease[index].metadata;
          const raw = JSON.parse(metadata).residual;
          const pct = parseFloat(raw && typeof raw === 'object' ? raw.value : raw);
          residualValue = isFinite(pct) ? this.residualBase * (pct + this.leaseAdjustment) / 100 : 0;
        }
      } catch (e) {
        residualValue = 0;
      }

      remaining = remaining - (this.effectiveLeaseRebate || 0);
      const total = this.leasePayment(remaining, residualValue) || 0;

      return this.leaseDisplayValue(total);
    },

    // calcula bounds mínimo/máximo para el slider (no muta downPayment persistente)
    computeLeaseSliderBounds() {
      // guarda estado actual
      const originalDP = this.downPayment;
      // máximo (cuando downPayment == 0)
      const maxVal = this.computeLeasePaymentForDownPayment(0);
      // mínimo (cuando downPayment == maxLeaseDownPayment -> límite del 20%)
      const maxDownPayment = this.maxLeaseDownPayment;
      const minVal = this.computeLeasePaymentForDownPayment(maxDownPayment);

      this.calculatedLeaseMax = maxVal;
      this.calculatedLeaseMin = minVal;

      // set initial slider value si no inicializado
      if (!this.calculatedLeaseValueSlider || this.calculatedLeaseValueSlider === 0) {
        // tomar el valor actual calculado
        this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
      }

      // restaurar estado (no fue modificado realmente en compute)
      this.downPayment = originalDP;
    },

    // snapshot del calculatedLeaseValue actual (llama calculateLeasePayment y devuelve valor)
    calculateLeaseValueSnapshot() {
      // llamar calculateLeasePayment para asegurar this.calculatedLeaseValue esté actualizado
      this.calculateLeasePayment();
      return this.calculatedLeaseValue || 0;
    },

    // cuando el usuario mueve el slider por calculatedLeaseValue
    onCalculatedLeaseSliderInput(targetValue) {
      // activa modo
      this.leaseSliderActive = true;
      this.calculatedLeaseValueSlider = targetValue;
      // busca el downPayment que produce targetValue (búsqueda binaria)
      const maxDownPayment = this.maxLeaseDownPayment;
      // Si no hay bounds calculados, calcularlos
      if (typeof this.calculatedLeaseMax === 'undefined' || typeof this.calculatedLeaseMin === 'undefined') {
        this.computeLeaseSliderBounds();
      }

      // comprobación rápida de extremos
      if (targetValue >= this.calculatedLeaseMax) {
        this.downPayment = 0;
        this.leaseDownPayment = 0;
        this.calculateLeasePayment();
        this.computeLeaseSliderBounds();
        return;
      }
      if (targetValue <= this.calculatedLeaseMin) {
        // Aplicar el límite del 20% en lugar del vehiclePrice completo
        this.downPayment = maxDownPayment;
        this.leaseDownPayment = maxDownPayment;
        // Mostrar mensaje indicando que se alcanzó el límite mínimo
        this.showLeaseCapMessage();
        this.calculateLeasePayment();
        this.computeLeaseSliderBounds();
        return;
      }

      let low = 0;
      let high = maxDownPayment; // Limitar la búsqueda al máximo permitido
      let mid = 0;
      let foundDp = 0;

      for (let i = 0; i < this.leaseSliderSearchIterations; i++) {
        mid = Math.round((low + high) / 2);
        const val = this.computeLeasePaymentForDownPayment(mid);
        if (Math.abs(val - targetValue) <= this.leaseSliderTolerance) {
          foundDp = mid;
          break;
        }
        // si val > targetValue => bajar pago significa aumentar downPayment
        if (val > targetValue) {
          low = mid + 1;
        } else {
          high = mid - 1;
        }
        foundDp = mid;
      }

      // Asegurar que el downPayment no exceda el límite del 20%
      foundDp = Math.min(foundDp, maxDownPayment);

      // aplicar downPayment encontrado
      this.downPayment = foundDp;
      this.leaseDownPayment = foundDp;
      // recalcular con nuevo downPayment
      this.calculateLeasePayment();
      // actualizar bounds porque downPayment cambió
      this.computeLeaseSliderBounds();
    },
    // --- fin nuevos métodos ---

    // --- Nuevos métodos para finance ---
    // calcula el finance payment (calculatedValue) para un downPayment dado (no muta this)
    computePaymentForDownPayment(downPaymentValue) {
      const tradeInValueN = (this.tradeInValue && this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      const dpN = downPaymentValue && downPaymentValue > 0 ? parseFloat(downPaymentValue) : 0;
      const vehiclePriceN = parseInt(this.vehiclePrice) || 0;

      let remaining = vehiclePriceN;
      if (tradeInValueN) remaining -= tradeInValueN;
      if (dpN) remaining = remaining - (dpN / this.provinceTaxValue);

      // determinar term e interestRate local según this.loanTerm y this.terms
      const term = this.loanTerm && this.loanTerm > 0 ? this.loanTerm : 60;
      let interestRateLocal = 0;
      try {
        const idx = this.terms.map(item => item.term).indexOf(term);
        if (idx !== -1) {
          const val = this.terms[idx].value;
          interestRateLocal = val > 50 ? parseFloat(Math.round(val * 100) / 100) / 100 : parseFloat(Math.round(val * 100) / 100);
        }
      } catch (e) {
        interestRateLocal = 0;
      }

      let total = 0;
      if (interestRateLocal == 0)
        total = Math.round((remaining / term) * 100) / 100;
      else
        total = Math.round((((remaining * (interestRateLocal / 1200)) * Math.pow((1 + (interestRateLocal / 1200)), term)) / (Math.pow((1 + (interestRateLocal / 1200)), term) - 1)) * 100) / 100;

      let calc = 0;
      if (this.frequency == "weekly")
        calc = Math.round(((total * 12) / 52).toFixed(2));
      else if (this.frequency == "bi-weekly")
        calc = Math.round(((total * 12) / 26).toFixed(2));
      else
        calc = Math.round(total.toFixed(2));

      if (this.isTaxed) {
        const provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
        calc = Math.round((calc * provinceDealerTax).toFixed(0));
      }
      return calc;
    },

    // Bounds para finance slider (no muta downPayment persistente)
    computeFinanceSliderBounds() {
      const vehiclePriceN = parseInt(this.vehiclePrice) || 0;
      const maxVal = this.computePaymentForDownPayment(0);
      const minVal = this.computePaymentForDownPayment(vehiclePriceN);
      this.calculatedFinanceMax = maxVal;
      this.calculatedFinanceMin = minVal;

      if (!this.calculatedFinanceValueSlider || this.calculatedFinanceValueSlider === 0) {
        this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
      }
    },

    calculateFinanceValueSnapshot() {
      this.calculatePayment();
      return this.calculatedValue || 0;
    },

    // cuando el usuario mueve el slider por calculatedValue (finance)
    onCalculatedFinanceSliderInput(targetValue) {
      this.financeSliderActive = true;
      this.calculatedFinanceValueSlider = targetValue;

      const vehiclePriceN = parseInt(this.vehiclePrice) || 0;
      if (typeof this.calculatedFinanceMax === 'undefined' || typeof this.calculatedFinanceMin === 'undefined') {
        this.computeFinanceSliderBounds();
      }

      // comprobación rápida de extremos
      if (targetValue >= this.calculatedFinanceMax) {
        this.downPayment = 0;
        this.financeDownPayment = 0;
        this.calculatePayment();
        this.computeFinanceSliderBounds();
        return;
      }
      if (targetValue <= this.calculatedFinanceMin) {
        this.downPayment = vehiclePriceN;
        this.financeDownPayment = vehiclePriceN;
        this.calculatePayment();
        this.computeFinanceSliderBounds();
        return;
      }

      let low = 0;
      let high = vehiclePriceN;
      let mid = 0;
      let foundDp = 0;

      for (let i = 0; i < this.financeSliderSearchIterations; i++) {
        mid = Math.round((low + high) / 2);
        const val = this.computePaymentForDownPayment(mid);
        if (Math.abs(val - targetValue) <= this.financeSliderTolerance) {
          foundDp = mid;
          break;
        }
        if (val > targetValue) {
          low = mid + 1;
        } else {
          high = mid - 1;
        }
        foundDp = mid;
      }

      this.downPayment = foundDp;
      this.financeDownPayment = foundDp;
      this.calculatePayment();
      this.computeFinanceSliderBounds();
    },
    // Los tabs (cash/lease/finance) se pintan condicionalmente desde el Blade, así que el
    // componente no sabe cuáles existen hasta que el DOM está montado. Si el tab pedido por
    // el setting no se renderizó, se cae en cascada finance -> lease -> cash.
    selectFirstAvailableTab() {
      if (!this.$el || !this.$el.querySelectorAll)
        return;

      const buttons = this.$el.querySelectorAll('.tabs-navigation [data-tab]');
      if (!buttons.length)
        return;

      const available = Array.prototype.map.call(buttons, btn => btn.getAttribute('data-tab'));
      const fallback = ['finance', 'lease', 'cash'].filter(tab => available.indexOf(tab) !== -1);
      const target = available.indexOf(this.selectedTab) !== -1
        ? this.selectedTab
        : (fallback[0] || available[0]);

      // toggleTab deja listos el downPayment y el snapshot del slider del tab elegido
      this.toggleTab(target);
    },
    toggleTab: function(tab) {
      // Cambiar al nuevo tab
      this.selectedTab = tab;

      // Ocultar mensaje de warning si estaba visible
      this.showLeaseCapWarning = false;

      // Restaurar downPayment al valor persistente correspondiente al tab
      if (tab === 'cash') {
        this.downPayment = 0;
      } else if (tab === 'finance') {
        this.downPayment = this.financeDownPayment;
        // Asegurar que los bounds del slider de finance estén calculados
        this.computeFinanceSliderBounds();
        this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
      } else if (tab === 'lease') {
        // Restaurar el down payment específico de lease
        this.downPayment = this.leaseDownPayment;
        // Validar que no exceda el límite del 20%
        const maxDownPayment = this.maxLeaseDownPayment;
        if (this.downPayment > maxDownPayment) {
          this.downPayment = maxDownPayment;
          this.leaseDownPayment = maxDownPayment;
        }
        // Asegurar que los bounds del slider de lease estén calculados
        this.computeLeaseSliderBounds();
        this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
      }
    },
  },
  computed: {
    // Base the lease residual % applies to: the feed's residualizable MSRP
    // (no freight or dealer fees), else the sale price as before. Without a
    // price it keeps the old base: on a $0 cap cost the lease would go negative.
    residualBase() {
      const residualMsrp = parseFloat(this.residualMsrp) || 0;
      return residualMsrp > 0 && parseFloat(this.vehiclePrice) > 0 ? residualMsrp : this.salePrice;
    },
    // El incentivo federal de EV escala con el plazo, pero el feed manda un valor unico.
    // Sin factor para el plazo actual se usa el del plazo inferior mas cercano.
    effectiveLeaseRebate() {
      const base = parseFloat(this.leaseRebateValue) || 0;
      const scale = this.leaseRebateScale;
      if (!base || !scale || typeof scale !== 'object') return base;

      const terms = Object.keys(scale).map(Number).filter(n => isFinite(n)).sort((a, b) => a - b);
      if (!terms.length) return base;

      const term = parseFloat(this.loanTermLease);
      const lower = terms.filter(t => t <= term).pop();
      const factor = parseFloat(scale[String(lower !== undefined ? lower : terms[0])]);
      return isFinite(factor) ? base * factor : base;
    },

    //! Cálculo del ángulo actual basado en el valor del pago inicial
    leaseTotalAngle(){
      return 360 - this.leaseStartAngle + this.leaseEndAngle;
    },

    leaseCurrentAngle() {
      return this.leasePaymentToAngle(this.leaseSliderValue);
    },

    leaseHandlePosition() {
      return this.leasePolarToCartesian(this.leaseCurrentAngle);
    },
    leaseAdjustment() {
      if (!this.metadataLease)
        return 0;
      try {
        if(this.metadataLease.adjustments.adjustment){
            var optionIndex = this.metadataLease.adjustments.adjustment.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
            return this.metadataLease.adjustments.adjustment[optionIndex]?.adjustment || 0;
        }else{
            var optionIndex = this.metadataLease.adjustments.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
            return this.metadataLease.adjustments[optionIndex]?.adjustment || 0;
        }

      } catch (e) {
        return 0;
      }
    },
    hasKmsAllowance() {
      if (!this.metadata || !this.metadata.adjustments)
        return false;
      else
        return true;
    },
    hasKmsAllowanceLease() {
      if (!this.metadataLease || !this.metadataLease.adjustments)
        return false;
      else
        return true;
    },
    metadata() {
      if (!this.isLease)
        return null;

      var optionIndex = this.lease.map(item => { return item.term }).indexOf(this.loanTerm);
      if (optionIndex == -1)
        return null;
      else
        try {
          return JSON.parse(this.lease[optionIndex].metadata) || null;
        }
        catch (e) {
          return null;
        }
    },
    metadataLease() {
      var optionIndex = this.lease.map(item => { return item.term }).indexOf(this.loanTermLease);
      if (optionIndex == -1)
        return null;
      else
        try {
          return JSON.parse(this.lease[optionIndex].metadata) || null;
        }
        catch (e) {
          return null;
        }
    },
    allowanceMileages() {
        // This calculation was changed because the Finance|Lease toggle button does not influence this issue.
        // NOTE: The lease total does not change according to the mileage, but rather according to the adjustment.
        if(this.metadataLease && this.metadataLease.adjustments){
            if(this.metadataLease.adjustments.adjustment)
                var obj = this.metadataLease.adjustments.adjustment;
            else
                var obj = this.metadataLease.adjustments;

            var allowedMileages = {};

            for (const prop in obj)
                allowedMileages[prop] = obj[prop]["mileage"];
            return allowedMileages;

        }else
            return null;
    },
    residual() {
      return 0;
    },
    remainingVehiclePrice() {
      var downPaymentN;
      var tradeInValueN;


      if (this.downPayment) {
        downPaymentN = (this.downPayment > 0) ? parseInt(this.downPayment) : 0;
      } else {
        downPaymentN = 0;
      }

      if (this.tradeInValue) {
        tradeInValueN = (this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      } else {
        tradeInValueN = 0;
      }

      this.$cookies.set('downPayment', downPaymentN);
      this.$cookies.set('tradeInValue', tradeInValueN);

      var vehiclePrice = parseInt(this.vehiclePrice);
      var result = vehiclePrice;

      //Complex calculation
      //let provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
      //this.isTaxed ? result = result * provinceDealerTax : result;

      if(tradeInValueN || downPaymentN) {
        if (tradeInValueN) {
          result = result - tradeInValueN;
        }

        if (downPaymentN) {
          result = (result) -  (downPaymentN / this.provinceTaxValue) ;
        }
      }
      else{
        //result = (result * this.provinceTaxValue);
      }


      return result;
    },
    selectedMethod() {
      if (this.isLease)
        return this.lease;
      else
        return this.finance;
    },
    terms() {
      var duplicatedMonths = (this.finance || []).map(item => { return { term: item.term, value: item.value } });
      var visited = [];
      var months = duplicatedMonths.filter(item => {
        if (visited.indexOf(item.term) == -1) {
          visited.push(item.term);
          return item;
        }
      })
      if (months == null) {
        return [];
      }
      return months
    },
    termsLease() {
      var duplicatedMonths = (this.lease || []).map(item => { return { term: item.term, value: item.value } });
      var visited = [];
      var months = duplicatedMonths.filter(item => {
        if (visited.indexOf(item.term) == -1) {
          visited.push(item.term);
          return item;
        }
      })
      if (months == null) {
        return [];
      }
      return months
    },
    termsOptions() {
      return this.terms.sort((a, b) => a.term - b.term).map(item => { return item.term });
    },
    termsOptionsLease() {
      return this.termsLease.sort((a, b) => a.term - b.term).map(item => { return item.term });
    },
    // Máximo down payment permitido para lease (20% del MSRP o vehiclePrice)
    // El límite se aplica al capitalized cost reduction EFECTIVO para que el pago mínimo sea consistente
    // IMPORTANTE: El down payment se divide por provinceTaxValue antes de aplicarse,
    // pero el trade-in se resta directamente. Para que el pago mínimo sea el mismo,
    // aplicamos el límite al valor efectivo: (downPayment / provinceTaxValue) + tradeIn <= 20% del MSRP
    maxLeaseDownPayment() {
      // Usar MSRP si está disponible, sino usar vehiclePrice
      const baseValue = this.totalMSRP && this.totalMSRP > 0 ? parseFloat(this.totalMSRP) : parseFloat(this.vehiclePrice) || 0;
      // Calcular 20% del valor base (límite EFECTIVO que se resta del precio)
      const maxTotalCapitalizedCostReductionEffective = baseValue * 0.20;
      
      // Obtener el valor actual del trade-in
      const tradeInValueN = (this.tradeInValue && this.tradeInValue.length > 0) ? parseFloat(this.tradeInValue) : 0;
      
      // El límite efectivo es: (downPayment / provinceTaxValue) + tradeIn <= maxTotalCapitalizedCostReductionEffective
      // Por lo tanto: downPayment <= (maxTotalCapitalizedCostReductionEffective - tradeIn) * provinceTaxValue
      const maxDownPaymentEffective = maxTotalCapitalizedCostReductionEffective - tradeInValueN;
      const maxDownPayment = Math.max(0, Math.round(maxDownPaymentEffective * this.provinceTaxValue));
      
      return maxDownPayment;
    },
  },
  watch: {
    remainingVehiclePrice() {
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    // cuando cambian variables relevantes recomputar bounds del slider de lease
    loanTermLease() {
      this.computeLeaseSliderBounds();
    },
    frequency() {
      this.computeLeaseSliderBounds();
      // frequency también afecta el cálculo de finance/lease payments
      this.computeFinanceSliderBounds();
    },
    vehiclePrice() {
      this.computeLeaseSliderBounds();
      this.computeFinanceSliderBounds();
    },
    tradeInValue() {
      // Si estamos en lease, validar que el down payment no exceda el nuevo límite
      // (porque el trade-in afecta el máximo down payment permitido)
      if (this.selectedTab === 'lease') {
        const downPaymentNum = parseFloat(this.downPayment) || 0;
        const maxDownPayment = this.maxLeaseDownPayment;
        if (downPaymentNum > maxDownPayment) {
          this.downPayment = maxDownPayment;
          this.leaseDownPayment = maxDownPayment;
        }
      }
      // recalcula lease y bounds, y actualiza el slider que muestra el lease value
      this.calculateLeasePayment();
      this.computeLeaseSliderBounds();
      this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
      // recalcula finance y bounds/slider
      this.calculatePayment();
      this.computeFinanceSliderBounds();
      this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
    },
    // cuando cambia el downPayment actualizar lease y el slider
    downPayment() {
      this.calculateLeasePayment();
      this.computeLeaseSliderBounds();
      this.calculatedLeaseValueSlider = this.calculateLeaseValueSnapshot();
      // y finance
      this.calculatePayment();
      this.computeFinanceSliderBounds();
      this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
    },
    provinceTax() {
      this.provinceTaxValue = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
      this.computeLeaseSliderBounds();
      this.computeFinanceSliderBounds();
    },
    // cuando cambia el loan term de FINANCE actualizar bounds/slider
    loanTerm() {
      this.changeInterestRate();
      this.computeFinanceSliderBounds();
      this.calculatedFinanceValueSlider = this.calculateFinanceValueSnapshot();
    },
  },
  filters: {

  },
  beforeMount() {
    try {
      const mileages = this.allowanceMileages;
      if (mileages && Object.keys(mileages).length > 0)
        this.kilometersAllowance = mileages[0];
    } catch (e) {}

    this.calculateVehiclePrice();
    this.calculatePayment();
    this.calculateLeasePayment();
  },
  mounted() {
    this.selectFirstAvailableTab();
  },
  created() {
    if (!Array.isArray(this.finance) || this.finance.length == 0)
      this.finance = this.termsMock;
    if (!Array.isArray(this.lease) || this.lease.length == 0)
      this.lease = this.termsMock;

    // inicializar bounds para el nuevo slider
    this.computeLeaseSliderBounds();
    this.computeFinanceSliderBounds();

    // El feed puede marcar un término con bestDeal; si no viene, se mantiene el último.
    const bestDealTerm = (list) => {
      if (!Array.isArray(list)) return null;
      for (const item of list) {
        let md = item && item.metadata;
        if (!md) continue;
        if (typeof md === 'string') {
          try { md = JSON.parse(md); } catch (e) { continue; }
        }
        if (md && (md.bestDeal === true || md.bestDeal === 'true')) return item.term;
      }
      return null;
    };

    const bestFinance = bestDealTerm(this.finance);
    const bestLease = bestDealTerm(this.lease);

    this.loanTerm = (bestFinance !== null && this.termsOptions.indexOf(bestFinance) !== -1)
      ? bestFinance
      : this.termsOptions[this.termsOptions.length - 1];
    this.loanTermLease = (bestLease !== null && this.termsOptionsLease.indexOf(bestLease) !== -1)
      ? bestLease
      : this.termsOptionsLease[this.termsOptionsLease.length - 1];
    this.setInterestRate();
    this.setInterestRateLease();
  },
}
